import { render, staticRenderFns } from "./helpCenterView.vue?vue&type=template&id=0204fac4"
import script from "./helpCenterView.vue?vue&type=script&lang=ts"
export * from "./helpCenterView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports